import { render } from "./AppShell.3.vue?vue&type=template&id=18c1b9cb&scoped=true&ts=true"
import script from "./AppShell.3.vue?vue&type=script&lang=ts"
export * from "./AppShell.3.vue?vue&type=script&lang=ts"

import "./styles/DFStyle_SiteIndex_Template.less?vue&type=style&index=0&lang=less&external"
import "./AppShell.3.vue?vue&type=style&index=1&id=18c1b9cb&lang=css"
import "./AppShell.3.vue?vue&type=style&index=2&id=18c1b9cb&lang=less&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c1b9cb"]])

export default __exports__